import { StyleSheet } from 'react-native';
import theme from '../../common/theme';

export const styles = StyleSheet.create({
  modalContainer: {
    padding: 40,
    alignItems: 'center',
    borderRadius: theme.radius.l,
    backgroundColor: theme.palette.white,
    ...theme.shadow.strong,
    overflow: 'hidden',
  },
  btnBack: {
    position: 'absolute',
    top: 30,
    left: 40,
    zIndex: 999,
  },
  content: {
    width: '100%',
  },
  title: {
    flex: 1,
    fontSize: 16,
    lineHeight: 22,
    textAlign: 'center',
    marginTop: 4,
    fontFamily: theme.fonts.medium,
    color: theme.palette.mono800,
  },
  search: {
    width: 620,
    marginTop: 40,
    marginBottom: 20,
  },
  loading: {
    height: 200,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.mono100,
  },
  table: {
    maxHeight: 400,
  },
  scrollDevices: {
    rowGap: 4,
  },
  scrollList: {
    rowGap: 8,
  },
  group: {
    marginBottom: 20,
  },
  rowOrg: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.mono100,
  },
  rowParent: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.mono100,
  },
  rowChild: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 16,
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: theme.palette.mono300,
  },
  textParent: {
    flex: 1,
    fontSize: 14,
    lineHeight: 20,
    color: theme.palette.mono800,
    fontFamily: theme.fonts.regular,
    fontVariant: ['tabular-nums'],
  },
  textChild: {
    flex: 1,
    color: theme.palette.mono800,
    fontVariant: ['tabular-nums'],
    fontFamily: theme.fonts.regular,
  },
  emptyText: {
    fontSize: 14,
    lineHeight: 20,
    color: theme.palette.mono600,
    fontFamily: theme.fonts.regular,
  },
  deviceText: {
    flex: 1,
    rowGap: 4,
    paddingVertical: 10,
  },
  deviceInfoText: {
    fontSize: 13,
    lineHeight: 16,
    fontVariant: ['tabular-nums'],
    fontFamily: theme.fonts.regular,
    color: theme.palette.mono600,
  },
  deviceInfoTextUnpaired: {
    color: theme.palette.red,
  },
  printerLabel: {
    lineHeight: 20,
    marginRight: 10,
    textAlign: 'right',
    color: theme.palette.red,
  },
});
